<template>
  <v-dialog v-model="dialog" persistent width="350">
    <transition :duration="150">
      <div class="modal">
        <!-- <CloseModalBtn :closeModal="closeModal" /> -->
        <img src="~/assets/img/logo_footer.svg" alt="ProApp" />
        <div class="form">
          <v-radio-group v-model="langSelect" hide-details class="group">
            <v-radio
              class="customRadio"
              v-for="(lang, key) in languages"
              :key="key"
              :value="lang"
              @click="clickLang(lang, key)"
            >
              <template v-slot:label>
                <img :src="lang.image.svg" alt="" />
                <span class="f16">{{ lang.name }}</span>
              </template>
            </v-radio>
          </v-radio-group>
          <div class="container_btn">
            <BaseButton @click="onLanguageSave()" :disabled="!langSelect" text="OK">
              <template v-slot:icon>
                <svg
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.744 1.39765L15.2199 0.873552C15.0552 0.708739 14.8356 0.618073 14.6012 0.618073C14.3668 0.618073 14.1471 0.708739 13.9824 0.873552L6.61815 8.23771L2.01704 3.63648C1.85236 3.47192 1.63265 3.38113 1.39824 3.38113C1.16397 3.38113 0.94439 3.47192 0.779577 3.63648L0.25535 4.16044C0.0905366 4.32552 0 4.54535 0 4.7795C0 5.01378 0.0905366 5.23348 0.25535 5.3983L5.45028 10.593C5.45717 10.6027 5.46446 10.6118 5.47291 10.6201L5.99714 11.1357C6.16182 11.2998 6.38153 11.3819 6.61776 11.3819H6.62049C6.85502 11.3819 7.07473 11.2998 7.23915 11.1357L7.76351 10.6156C7.77197 10.6073 7.77912 10.6004 7.78341 10.5933L15.7439 2.63368C16.0853 2.293 16.0853 1.73872 15.744 1.39765Z"
                    fill="#F2F2F2"
                  />
                </svg>
              </template>
            </BaseButton>
          </div>
        </div>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'LanguagesChangeModal',
  data() {
    return {
      dialog: false,
      langSelect: null,
    }
  },
  created() {
    if (!this.$cookies.get('languageSelect')) {
      this.openModal()
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['apiDomain']),
    ...mapGetters('languages', ['languages']),
    windowWidth() {
      return this.$vuetify.breakpoint.width
    },
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    clickLang(lang, key) {
      this.langSelect = lang
      this.langSelect.key = key
    },
    onLanguageSave() {
      this.$cookies.set('languageSelect', this.langSelect, '1y', null, null, false, 'Strict')
      this.closeModal()
      this.$router.go(0)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 30px;
  position: relative;
  .contactImg {
    width: 100%;
    max-width: 100px;
    height: auto;
    margin-bottom: 10px;
  }
  .close {
    padding: 16px;
  }
  .group {
    margin: 0;
    padding: 0;
    width: 250px;
  }
  .form {
    display: grid;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-items: center;
    row-gap: 30px;
  }
  :deep().customRadio {
    // display: block;
    .v-input--selection-controls__input {
      order: 2;
      margin-right: 0;
      margin-left: 8px;
    }
    label {
      order: 1;
      display: flex;
      column-gap: 10px;
      text-transform: capitalize;
      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid rgb(221, 221, 221);
      }
    }
  }
}
</style>
